const SgDateInputTypes = {
    DATEPICKER: 'DATEPICKER',
    YEAR_ONLY: 'YEAR_ONLY',
    MONTH_DROPDOWN: 'MONTH_DROPDOWN',
    MONTH_YEAR_PICKER: 'MONTH_YEAR_PICKER',
    MONTH_YEAR_INPUTS: 'MONTH_YEAR_INPUTS',
    DAY_MONTH_YEAR_INPUTS: 'DAY_MONTH_YEAR_INPUTS',
    READONLY: 'READONLY',
    READONLY_WITH_LABEL: 'READONLY_WITH_LABEL'
};

export default SgDateInputTypes;
